/**
* @name: frameBody
* @author: weiyong
* @date: 2022-10-02 22:10
* @description：frameBody
* @update: 2022-10-02 22:10
*/
<template>
  <div :class="prefixCls" class="app-body">
    <frame-sub-menu  :itemMenu="itemMenu"></frame-sub-menu>

    <div :class="[prefixCls+'-frame-body',getMenuFlag?'expand':'min']">
     <div class="body-content wh100b" style="position: relative;">
       <div class="getLayoutContentModeBg" :style="LayoutContentSty">
         <div class="portal-workbench-background-mask" :style="maskSty"></div>
       </div>
       <div class="showApp" v-if="showApp"></div>
       <div  :class="[prefixCls+'-frame-body-div']" style="z-index: 10;position: relative">
         <!--主应用界面-->
         <RouterView :showApp="showApp" class="subAppMain" v-if="$route.name&&$route.name!=='PageNotFound'&&$route.name!=='PageNotFoundSon'">
         </RouterView>
         <!-- 子应用界面 -->
         <div class="go-page " v-if="!$route.name||$route.name==='PageNotFound'||$route.name==='PageNotFoundSon'" id="frame"></div>
         <slot></slot>
       </div>
     </div>

    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "frameBody",
});
</script>

<script lang="ts" setup>
import { useRoute } from 'vue-router';
import {PageHeader as aPageHeader} from "ant-design-vue";
import FrameSubMenu from "@/layouts/layoutFrame/appFrame/appFrameCom/frameSubMenu.vue";
import {useDesign} from "@/hooks/web/useDesign";
import {useSubAppInfos} from "@/hooks/layouts/useSubAppInfos";
import {toRefs, ref, computed} from "vue";
import {StorageUtils} from 'xmgoing-utils';
import {useHeaderSetting} from "@/hooks/setting/useHeaderSetting";

const {
  getPageBgColor,
  getPageBgOpAcityVal,
  getPageBgFilterVal,
  getPageBgImgSrc,
  getBackShowType,
  getMaskColor,
} = useHeaderSetting();

const {prefixCls} = useDesign('frameBody');
const {getMenuFlag} = useSubAppInfos();

const props = defineProps({
  itemMenu:{
    type:Object
  }
})
const router = useRoute();
const {meta}=toRefs(router);

const showApp=ref(StorageUtils.getSessionItem("showApp")||false)

const LayoutContentSty = computed(() => {
  let sty:any = {
    backgroundColor: unref(getPageBgColor),
    backgroundImage: `url(${unref(getPageBgImgSrc)})`,
    filter: `blur(${unref(getPageBgFilterVal) || 10}px`,
  };
  //如果是图片背景
  if(unref(getBackShowType) !== 'imgBg'){
    delete sty['backgroundImage'];
    delete sty['filter'];
  }else{
    sty['filter']='blur(1px)';
  }
  return sty;
});

const maskSty = computed(()=>{
  return {
    opacity:`${parseInt(unref(getPageBgOpAcityVal))/100}`,
    backgroundColor:unref(getMaskColor)||'#eee',
  }
})


</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-frameBody';

@menu-body: 220px;
@menu-min-body: 66px;

.@{prefix-cls} {
  display: flex;height: calc(100% - 52px);background-color: #F0F2F5;


  .ant-page-header{
    background-color: #FFF;
  }
  .@{prefix-cls}-frame-body{
    padding: 0px;
    width: 100%;
    margin-left: 220px;
    overflow: hidden;
    &.expand{
      margin-left: @menu-body;
    }
    &.min{
      margin-left: @menu-min-body;
    }

    .portal-workbench-background-mask {
      width: 100%;
      height: 100%;
    }

    .getLayoutContentModeBg {
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: hidden;
      width: 100%;
      height: 100%;
      background-size: cover;
      filter: blur(14px);
    }
  }

  .@{prefix-cls}-frame-body-div{

    width: 100%;
    height: 100%;
    #frame{
      padding: var(--padding-common-lr,16px);
    }
    .subAppMain{
      width: 100%;
      height: 100%;
    }
  }



  .header__title--active {
    color: #333;
    font-weight: 700;
    background-color: #FFF;
    padding:12px 16px;

    font-size: 18px;
    margin-bottom: 12px;
    position: relative;
    flex: 1;
  }
}
</style>
